const breadcrumbs: Record<string, string | Record<string, string>> = {
    campaigns: 'Сборы сведений',
    campaign: 'Сбор сведений',
    requests: 'Предоставленные сведения',
    campaignSettings: 'Настройки конкурса',
    regFormSelect: 'Выбор формы подачи сведений',
};

export default breadcrumbs;
